import { Card, Form, message, Typography } from "antd";
import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { logo } from "../../../constants/common";
import { useAuth } from "../../../hooks/useAuth";
import { ResetPasswordForm } from "../components/ResetPasswordForm";
import { SendOtpForm } from "../components/SendOtpForm";

const { Title, Text } = Typography;

const STEPS = {
  SEND_OTP: 1,
  RESET_PASSWORD: 2,
};

const styles = {
  wrapper: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 20,
  },
  card: {
    width: "100%",
    maxWidth: 500,
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
    borderRadius: 12,
  },
  header: {
    textAlign: "center",
    marginBottom: 32,
  },
  logo: {
    width: 64,
    height: 64,
    marginBottom: 16,
  },
  title: {
    margin: 0,
    color: "#147265",
    marginBottom: 8,
  },
  subtitle: {
    fontSize: 14,
  },
};

export function ResetPassword() {
  const [step, setStep] = useState(STEPS.SEND_OTP);
  const [email, setEmail] = useState("");

  const navigate = useNavigate();
  const { sendOtp, resetPassword } = useAuth();

  const [sendOtpForm] = Form.useForm();
  const [resetForm] = Form.useForm();

  const resetState = useCallback(() => {
    sendOtpForm.resetFields();
    resetForm.resetFields();
    setEmail("");
    setStep(STEPS.SEND_OTP);
  }, [sendOtpForm, resetForm]);

  const handleSendOtp = async (values) => {
    setEmail(values.email);
    try {
      await sendOtp.mutateAsync(values);
      setStep(STEPS.RESET_PASSWORD);
    } catch (error) {
      message.error(`${error}` || "Yêu cầu thất bại.");
    }
  };

  const handleResetPassword = async (values) => {
    try {
      await resetPassword.mutateAsync({ ...values, email });
      message.success("Đổi mật khẩu thành công.");
      resetState();
      navigate("/xac-thuc/dang-nhap");
    } catch (error) {
      message.error(`${error}` || "Đổi mật khẩu thất bại.");
    }
  };

  const isSendOtpStep = step === STEPS.SEND_OTP;

  return (
    <div style={styles.wrapper}>
      <Card style={styles.card}>
        <div style={styles.header}>
          <img src={logo} alt="Chùa Diệu Pháp" style={styles.logo} />

          <Title level={2} style={styles.title}>
            {isSendOtpStep ? "Quên mật khẩu" : "Đặt lại mật khẩu"}
          </Title>

          <Text type="secondary" style={styles.subtitle}>
            {isSendOtpStep
              ? "Nhập email để nhận mã OTP đặt lại mật khẩu"
              : "Nhập mã OTP và mật khẩu mới"}
          </Text>
        </div>

        {isSendOtpStep ? (
          <SendOtpForm
            form={sendOtpForm}
            loading={sendOtp.isPending}
            onSubmit={handleSendOtp}
          />
        ) : (
          <ResetPasswordForm
            form={resetForm}
            loading={resetPassword.isPending}
            onSubmit={handleResetPassword}
          />
        )}
      </Card>
    </div>
  );
}
